<div class="card card-w-title mobile-padding-0 multiple-signup-res">
    <p-accordion [(activeIndex)]="index">
        <p-accordionTab [disabled]="true" [header]='setLabel("detailsHeaderLabel")'>
            <br />
            <div class="profileImgContainer">
                <div class="p-g-3 imgstyle">
                    <img style="width: 200px; height: 200px"
                    [src]="!uploadProfile
                    ? member.profile
                    ? config.Server + config.memberImagePath + member.profile
                    : member.gender && member.gender == 'F'
                    ? 'assets/layout/images/avatarGirlImage.png'
                    : 'assets/layout/images/avatarBoyImage.png'
                    : member.profile
                    ? member.profile
                    : member.gender && member.gender == 'F'
                    ? 'assets/layout/images/avatarGirlImage.png'
                    : 'assets/layout/images/avatarBoyImage.png'
                    "  onerror="this.src = 'assets/layout/images/avatarBoyImage.png'"/>
                </div>
                <div class="userDetailToolBar">
                    <h3 class="first">{{setLabel("profilePictureLabel")}}</h3>

                    <button (click)="captureImageDialogShow('Cam')" class="">
                        <span class="p-button-text p-c">
                            <i class="fa fa-camera" aria-hidden="true"></i> &nbsp;{{setLabel("capturePhotoBtnLabel")}}
                        </span>
                    </button>
                    <button (click)="captureImageDialogShow('Upload')" class="">
                        <span class="p-button-text p-c">
                            <i class="fa fa-upload" aria-hidden="true"></i> &nbsp;{{setLabel("uploadPhotoBtnLabel")}}
                        </span>
                    </button>
                    <button (click)="removeProfileImage()" class="removePhoto">
                        <span class="p-button-text p-c">
                            <i class="fa fa-times"></i> &nbsp;{{setLabel("removePhotoBtnLabel")}}
                        </span>
                    </button>

                </div>
            </div>

            <div class="p-g-12">
                <button id="addEM" (click)="existingMembersDialog= true"
                    class="p-button p-widget p-state-default p-corner-all">
                    <span class="p-button-text p-c">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                        &nbsp;{{setLabel("addExistingMemberLabel")}} ( F2 )
                    </span>
                </button>
                <!-- <input type="button" id="addEM" (keyup)="addExistingMember($event)" placeholder="Add Existing Member(F2)"> -->
            </div>
            <div>
                <form #memberSignUpForm="ngForm">
                    <div class="p-g-12 multiple-signup-detail-1-res">

                        <div class="p-g-6" style="text-align: left">
                            <div class="p-g p-fluid">
                                <h3 class="first">
                                   {{setLabel("membershipNumberLabel")}}
                                    <span style="color: red">*</span>
                                </h3>
                                <div class="p-g-12">
                                    <div class="p-inputgroup">
                                        <span class="p-inputgroup-addon"><i class="fa fa-tags"
                                                aria-hidden="true"></i></span>
                                        <input type="number" pattern="[0-9]+" required pInputText #tagNumber="ngModel"
                                        [placeholder]='setLabel("membershipNumber*PlaceholderLabel")' autocomplete="off" [ngClass]="tagNumber.invalid &&
                                                                    (tagNumber.dirty ||
                                                                    tagNumber.touched)
                                                                    ? 'errorInput'
                                                                    : ''" name="tagNumber"
                                            [(ngModel)]="member.tagNumber" (input)="membershipValidation()" readonly />
                                    </div>
                                    <div *ngIf="tagNumber.invalid &&
                                                                (tagNumber.dirty ||
                                                                tagNumber.touched)">
                                        <div *ngIf="tagNumber.errors.required" class="errorShow">
                                            {{setLabel("membershipCorrectlyErrorLabel")}}
                                        </div>
                                        <div *ngIf="tagNumber.errors.pattern" class="errorShow">
                                            {{setLabel("membershipCorrectlyErrorLabel")}}
                                        </div>
                                    </div>
                                    <div *ngIf="x == true" class="errorShow">
                                        {{setLabel("membershipexistsErrorLabel")}}
                                    </div>
                                </div>

                                <h3 class="first">
                                    {{setLabel("memberDetailsLabel")}}
                                    <span style="color: red">*</span>
                                </h3>
                                <div class="p-g-12">
                                    <div class="p-inputgroup">
                                        <span class="p-inputgroup-addon"><i class="fa fa-user"
                                                aria-hidden="true"></i></span>
                                        <input autocomplete="off" id="memberName" pattern="[A-Za-z ]+" [ngClass]="memberName.invalid
                                                                                                    &&
                                                                                                    (memberName.dirty ||
                                                                                                    memberName.touched)
                                                                                                    ? 'errorInput'
                                                                                                    : ''" type="text"
                                            autofocus pInputText [placeholder]='setLabel("name*PlaceholderLabel")' #memberName="ngModel" name="name"
                                            required [(ngModel)]="member.name" />
                                    </div>
                                    <div *ngIf="memberName.invalid &&
                                                                (memberName.dirty ||
                                                                memberName.touched)">
                                        <div *ngIf="memberName.errors.required" class="errorShow">
                                            {{setLabel("nameErrorLabel")}}
                                        </div>
                                        <div *ngIf="memberName.errors.pattern" class="errorShow">
                                            {{setLabel("nameCharactersErrorLabel")}}
                                        </div>
                                    </div>
                                </div>
                                <h3 class="first">{{setLabel("genderLabel")}}</h3>
                                <div class="p-g-12">
                                    <div class="p-g-6">
                                        <p-radioButton name="gender" (change)="changeProfile()"
                                            (ngModelChange)="changeProfile()" value="M" [label]='setLabel("maleLabel")' id="gender"
                                            [(ngModel)]="member.gender" inputId="opt1"
                                            [ngClass]="member.gender === 'M' && currentStep == 1 ? 'radioBtnHighlite' : ''">
                                        </p-radioButton>
                                    </div>
                                    <div class="p-g-6">
                                        <p-radioButton name="gender" (change)="changeProfile()"
                                            (ngModelChange)="changeProfile()" value="F" [label]='setLabel("femaleLabel")' id="gender"
                                            [(ngModel)]="member.gender" inputId="opt2"
                                            [ngClass]="member.gender === 'F' && currentStep == 1 ? 'radioBtnHighlite' : ''">
                                        </p-radioButton>
                                    </div>
                                </div>

                                <h3 class="first">
                                    {{setLabel("mobileLabel")}}
                                    <span style="color: red">*</span>
                                </h3>
                                <div class="p-g-12">
                                    <app-phone-input
                                                [placeholder]="setLabel('mobile*PlaceholderLabel')"
                                                [(phoneNumber)]="member.contactDetail.contact"
                                                [initialCountry]="'PK'"
                                                (validNumber)="formattedNumber = $event"
                                                (formattedForSaving)="member.contactDetail.contact = $event"
                                                style="max-width: 600px; margin: auto; align-items: center;"
                                                #phoneNumber="ngModel" name="phoneNumber" ngModel [required]="true">
                                            </app-phone-input>
                                            <div *ngIf="!member.contactDetail.contact" class="validation-error"
                                                style="color: red; text-align: start;">
                                                {{setLabel("enterMobileNumberErrorLabel")}}
                                            </div>
                                </div>
                                <h3 class="first">{{setLabel("emailLabel")}}</h3>
                                <div class="p-g-12">
                                    <div class="p-inputgroup">
                                        <span class="p-inputgroup-addon"><i class="fa fa-envelope-o"
                                                aria-hidden="true"></i></span>
                                        <input type="email" autocomplete="off" pInputText [placeholder]='setLabel("emailPlaceholderLabel")'
                                            name="email" #email="ngModel" id="email"
                                            (input)="checkEmailExistEvent($event)"
                                            pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                            [(ngModel)]="member.email">
                                    </div>

                                    <div class="p-g-8" style="padding-top: 0px;">
                                        <ng-template [ngIf]="email.invalid && (email.dirty || email.touched)">
                                            <div>
                                                <div *ngIf="email.errors.required" class="errorShow">
                                                    {{setLabel("emailErrorLabel")}}
                                                </div>
                                                <div *ngIf="email.errors.pattern" class="errorShow">
                                                    {{setLabel("emailCorrectlyErrorLabel")}}
                                                </div>

                                            </div>
                                        </ng-template>

                                        <ng-template [ngIf]="isEmailExist">
                                            <div style="margin-left: 30px !important;color: red !important;">
                                                {{setLabel("emailTakenErrorLabel")}}
                                            </div>
                                        </ng-template>

                                    </div>
                                    <div class="p-g-4" style="padding-top: 2px;">
                                        <ng-template [ngIf]="isEmailLoader">
                                            <div class="p-g-12"
                                                style="text-align: end; padding-top: 0px; padding-right: 0px;">
                                                <div class="spinit ">
                                                    <i class="fa fa-spinner" aria-hidden="true"></i>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </div>

                                </div>
                            </div>

                            <div class="p-g-12">
                                <h3 class="first">{{setLabel("identityTypeLabel")}}</h3>
                                <div style="display: flex; gap: 3rem;" class="p-g-12">
                                    <p-radioButton name="identityType" [value]="'CNIC'" [(ngModel)]="selectedIdentityType"
                                         label="{{setLabel('cNICLabel')}}"></p-radioButton>
                                    <p-radioButton name="identityType" [value]="'Passport'" [(ngModel)]="selectedIdentityType"
                                         label="{{setLabel('passportLabel')}}"></p-radioButton>
                                </div>
                            </div>
                            <div *ngIf="selectedIdentityType === 'CNIC'" class="p-g-12">
                                <h3 class="first"> {{setLabel("cNICLabel")}}</h3>
                                <div class="p-inputgroup">
                                    <span class="p-inputgroup-addon"><i class="fa fa-id-card" aria-hidden="true"></i></span>
                                    <input
                                        type="text"
                                        autocomplete="off"
                                        pInputText
                                        #CNIC="ngModel"
                                        minlength="13"
                                        maxlength="13"
                                        pattern="[A-Za-z0-9]+"
                                        [placeholder]="member.CNIC ? '' : setLabel('cNICLabel')"
                                        name="CNIC"
                                        [(ngModel)]="member.CNIC"
                                     />
                                </div>
                                <div *ngIf="CNIC.invalid && (CNIC.dirty || CNIC.touched)" class="errorShow">
                                    <small *ngIf="CNIC.errors?.minlength">{{setLabel("cNIC13DigitsErrorLabel")}}</small>
                                </div>
                            </div>
                            <div *ngIf="selectedIdentityType === 'Passport'" class="p-g-12">
                                <h3 class="first"> {{setLabel("passportLabel")}}</h3>
                                <div class="p-inputgroup">
                                    <span class="p-inputgroup-addon"><i class="fa fa-id-card" aria-hidden="true"></i></span>
                                    <input
                                        type="text"
                                        autocomplete="off"
                                        pInputText
                                        #CNIC="ngModel"
                                        minlength="9"
                                        maxlength="9"
                                        pattern="[A-Za-z0-9]+"
                                        [placeholder]="member.CNIC ? '' : setLabel('passportLabel')"
                                        name="CNIC"
                                        [(ngModel)]="member.CNIC"
                                     />
                                </div>
                                <div *ngIf="CNIC.invalid && (CNIC.dirty || CNIC.touched)" class="errorShow">
                                    <small *ngIf="CNIC.errors?.minlength">{{setLabel("passport8DigitsErrorLabel")}}</small>
                                </div>

                            </div>

                            <!-- <h3 class="first">{{setLabel("cNICLabel")}}</h3>
                            <div class="p-g-12">
                                <div class="p-inputgroup">
                                    <span class="p-inputgroup-addon"><i class="fa fa-id-card" aria-hidden="true"></i></span>
                                    <input
                                        type="text"
                                        autocomplete="off"
                                        pInputText
                                        #CNIC="ngModel"
                                        minlength="8"
                                        maxlength="18"
                                        pattern="[A-Za-z0-9]+"
                                        [placeholder]='setLabel("cNICPlaceholderLabel")'
                                        name="CNIC"
                                        [(ngModel)]="member.CNIC"
                                         />
                                </div>
                                <div *ngIf="CNIC.invalid && (CNIC.dirty || CNIC.touched)"  class="errorShow">
                                    <small *ngIf="CNIC.errors?.minlength">{{setLabel("cNICPassportErrorNumber")}}</small>
                                </div>
                            </div> -->
                            <h3 class="first">
                                {{setLabel("emergencyContactNameLabel")}}
                            </h3>
                            <div class="p-g-12">
                                <div class="p-inputgroup">
                                    <span class="p-inputgroup-addon"><i class="fa fa-user"
                                            aria-hidden="true"></i></span>
                                    <input maxlength="100" autocomplete="off" id="emergencyName" pattern="[A-Za-z ]+"
                                      type="text" pInputText [placeholder]='setLabel("emergencyContactNamePlaceholderLabel")' #emergencyName="ngModel"
                                      name="emergencyName" [(ngModel)]="member.emergencyContact.name" />
                                </div>
                                <div *ngIf="
                                    emergencyName.invalid &&
                                    (emergencyName.dirty || emergencyName.touched)
                                ">
                                    <div *ngIf="emergencyName.errors.pattern" class="errorShow">
                                        {{setLabel("namelettersErrorLabel")}}
                                    </div>
                                </div>
                            </div>
                            <h3 class="first">
                                {{setLabel("emergencyContactMobileLabel")}}
                            </h3>
                            <div class="p-g-12">
                                <app-phone-input
                                    [placeholder]="setLabel('emergencyContactMobilePlaceholderLabel')"
                                    [(phoneNumber)]="member.emergencyContact.contact"
                                    [initialCountry]="'PK'"
                                    (validNumber)="formattedNumber = $event"
                                    (formattedForSaving)="member.emergencyContact.contact  = $event"
                                    style="max-width: 600px; margin: auto; align-items: center;">
                                    </app-phone-input>
                            </div>



                        </div>

                        <div class="p-g-6" style="text-align: left">
                            <div class="p-g p-fluid">
                                <h3 class="first">{{setLabel("joiningDateLabel")}}</h3>
                                <div class="p-g-12">
                                    <p-calendar [yearNavigator]="true" autofocus="true" inline="true"
                                        yearRange="1950:2040" [monthNavigator]="true" [(ngModel)]="member.joiningDate"
                                        id="joiningDate" [placeholder]='setLabel("joiningDatePlaceholderLabel")' name="joinDate" [inline]="false"
                                        dateFormat="dd/mm/yy" [showIcon]="true">
                                    </p-calendar>
                                </div>
                                <div *ngIf=" branchSessionStorage == '651a591aae5ff029ba201bd6' || branchSessionStorage == '67728682419e66d9220356ec'" >
                                    <h3 class="first">{{setLabel("dateOfBirthLabel")}} <span style="color: red">*</span>
                                    </h3>
                                </div>
                                <div *ngIf=" branchSessionStorage !== '651a591aae5ff029ba201bd6'  && branchSessionStorage !== '67728682419e66d9220356ec'" >
                                    <h3 class="first">{{setLabel("dateOfBirthLabel")}}
                                    </h3>
                                </div>
                                <div *ngIf="branchSessionStorage == '651a591aae5ff029ba201bd6' || branchSessionStorage == '67728682419e66d9220356ec'" class="p-g-12">
                                    <p-calendar [(ngModel)]="member.dateOfBirth" (ngModelChange)="onDateOfBirthChange()"
                                        [placeholder]="setLabel('dateOfBirthPlaceholderLabel')" name="dateOfBirth" [inline]="false" dateFormat="dd/mm/yy"
                                        [showIcon]="true" [maxDate]="maxDate" required #dateOfBirth="ngModel"
                                        [ngClass]="{'errorInput': dateOfBirth.invalid && (dateOfBirth.dirty || dateOfBirth.touched)}">
                                    </p-calendar>
                                    <div *ngIf="dateOfBirth.invalid && (dateOfBirth.dirty || dateOfBirth.touched)">
                                        <div *ngIf="dateOfBirth.errors.required" class="errorShow">
                                            {{setLabel("dateOfBirthErrorLabel")}}
                                        </div>
                                    </div>
                                    <div *ngIf="!isAgeValid" class="errorShow">
                                        {{setLabel("selectedPackageNotAgeGroupLabel")}}
                                    </div>
                                    <div *ngIf="dateOfBirthError" class="errorShow">
                                        {{setLabel("dateOfBirthErrorLabel")}}
                                   </div>
                                </div>
                                <div *ngIf="branchSessionStorage !== '651a591aae5ff029ba201bd6' && branchSessionStorage !== '67728682419e66d9220356ec'" class="p-g-12">
                                    <p-calendar [(ngModel)]="member.dateOfBirth" (ngModelChange)="onDateOfBirthChange()"
                                        [placeholder]="setLabel('dateOfBirthPlaceholderLabel')" name="dateOfBirth" [inline]="false" dateFormat="dd/mm/yy"
                                        [showIcon]="true" [maxDate]="maxDate" #dateOfBirth="ngModel"
                                        [ngClass]="{'errorInput': dateOfBirth.invalid && (dateOfBirth.dirty || dateOfBirth.touched)}">
                                    </p-calendar>
                                    <div *ngIf="!isAgeValid" class="errorShow">
                                        {{setLabel("SelectedPackageNotAgeGroupLabel")}}
                                    </div>
                                </div>
                                <!-- <div *ngIf="branchSessionStorage == '651a591aae5ff029ba201bd6'">
                                    <h3 class="first">{{setLabel("dateOfBirthLabel")}} <span style="color: red">*</span></h3>
                                </div>
                                <div *ngIf="branchSessionStorage !== '651a591aae5ff029ba201bd6'">
                                    <h3 class="first">{{setLabel("dateOfBirthLabel")}}</h3>
                                </div>

                                <div *ngIf="branchSessionStorage == '651a591aae5ff029ba201bd6'" class="p-g-12">
                                    <p-calendar [yearNavigator]="true" yearRange="1950:2040"
                                    [monthNavigator]="true" [(ngModel)]="member.dateOfBirth" required #dateOfBirth="ngModel"
                                    (ngModelChange)="onDateOfBirthChange()"
                                    [placeholder]='setLabel("dateOfBirthPlaceholderLabel")' name="dateOfBirth"
                                    [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true"
                                    [ngClass]="{'errorInput': dateOfBirth.invalid && (dateOfBirth.dirty || dateOfBirth.touched)}">
                                    </p-calendar>
                                    <div *ngIf="dateOfBirth.invalid && (dateOfBirth.dirty || dateOfBirth.touched)">
                                        <div *ngIf="dateOfBirth.errors.required" class="errorShow">
                                            {{setLabel("dateOfBirthErrorLabel")}}
                                        </div>
                                    </div>
                                    <div *ngIf="!isAgeValid" class="errorShow">
                                        {{setLabel("selectedPackageNotAgeGroupLabel")}}
                                    </div>
                                    <div *ngIf="dateOfBirthError" class="errorShow">
                                        {{setLabel("dateOfBirthErrorLabel")}}
                                   </div>
                                </div>
                                <div *ngIf="branchSessionStorage !== '651a591aae5ff029ba201bd6'" class="p-g-12">
                                    <p-calendar [yearNavigator]="true" yearRange="1950:2040"
                                    [monthNavigator]="true" [(ngModel)]="member.dateOfBirth" #dateOfBirth="ngModel"
                                    (ngModelChange)="onDateOfBirthChange()"
                                    [placeholder]='setLabel("dateOfBirthPlaceholderLabel")' name="dateOfBirth"
                                    [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true"
                                    [ngClass]="{'errorInput': dateOfBirth.invalid && (dateOfBirth.dirty || dateOfBirth.touched)}">
                                    </p-calendar>
                                    <div *ngIf="dateOfBirth.invalid && (dateOfBirth.dirty || dateOfBirth.touched)">
                                        <div *ngIf="dateOfBirth.errors.required" class="errorShow">
                                            {{setLabel("dateOfBirthErrorLabel")}}
                                        </div>
                                    </div>
                                    <div *ngIf="!isAgeValid" class="errorShow">
                                        {{setLabel("selectedPackageNotAgeGroupLabel")}}
                                    </div>
                                </div> -->
                                <h3 class="first">{{setLabel("addressLabel")}}</h3>
                                <div class="p-g-12">
                                    <div class="p-g-6">
                                        <div class="p-inputgroup">
                                            <span class="p-inputgroup-addon"><i class="fa fa-map-marker"
                                                    aria-hidden="true"></i></span>
                                            <input type="text" pInputText [placeholder]='setLabel("streetPlaceholderLabel")' id="street" name="street"
                                                autocomplete="off" [(ngModel)]="member.contactDetail.address.street"
                                                class="form-control" />
                                        </div>
                                    </div>

                                    <div class="p-g-3">
                                        <div class="p-inputgroup">
                                            <!-- <span class="p-inputgroup-addon"><i class="fa fa-map-marker" aria-hidden="true"></i></span> -->
                                            <input type="text" pInputText [placeholder]='setLabel("cityPlaceholderLabel")' name="city"
                                                autocomplete="off" [(ngModel)]="member.contactDetail.address.city"
                                                id="city" class="form-control" />
                                        </div>
                                    </div>
                                    <div class="p-g-3">
                                        <div class="p-inputgroup">
                                            <!-- <span class="p-inputgroup-addon"><i class="fa fa-map-marker" aria-hidden="true"></i></span> -->
                                            <input type="text" pInputText [placeholder]='setLabel("countryPlaceholderLabel")' name="country"
                                                autocomplete="off" [(ngModel)]="member.contactDetail.address.country"
                                                id="country" class="form-control" />
                                        </div>
                                    </div>
                                </div>

                                <!-- <h3 class="first">{{setLabel("covidVaccinated?Label")}}</h3>
                                <div class="p-g-12">
                                    <div class="p-g-6">
                                        <p-radioButton id="question1" name="question1" value="YES" [label]='setLabel("yESLabel")'
                                            [(ngModel)]="member.question1" inputId="opt1"
                                            [ngClass]="member.question1 === 'YES' && currentStep == 7 ? 'radioBtnHighlite' : ''">
                                        </p-radioButton>
                                    </div>
                                    <div class="p-g-6">
                                        <p-radioButton name="question1" value="NO" [label]='setLabel("nOLabel")'
                                            [(ngModel)]="member.question1" inputId="opt2"
                                            [ngClass]="member.question1 === 'NO' && currentStep == 7 ? 'radioBtnHighlite' : ''">
                                        </p-radioButton>
                                    </div>
                                </div> -->
                                <h3 class="first">{{setLabel("commentLabel")}}</h3>
                                <div class="p-g-12">
                                    <textarea rows="5" cols="67" id="description" name="description"
                                        [(ngModel)]="member.description" pInputTextarea  [placeholder]="member.description ? '' : 'Enter Your Comments Here'"></textarea>
                                    <div>
                                        <p style="margin-top: 0px; font-size: smaller; font-family: inherit;">
                                            {{setLabel("pressLabel")}}&nbsp;<span
                                                style="font-weight: bold; font-family: monospace;">{{setLabel("sHift+EnterLabel")}}</span>&nbsp;{{setLabel("goNextLineLabel")}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="p-g-12" *ngIf="!subPackage.isGreaterthanNoOfMembers">
                        <button type="button" id="proceedButton"
                            *ngIf="isMembersRegistered || (!subPackage.isGreaterthanNoOfMembers && members.length >= noOfMembers - 1)"
                            [disabled]="!memberSignUpForm.form.valid || isDisableOnTypeEmail || !member.contactDetail.contact"
                            (click)="validateMembersSignup(memberSignUpForm)" class="p-button
                                            p-widget
                                            p-state-default
                                            p-corner-all">
                            <span class="p-button-text p-c">{{setLabel("proceedBtnLabel")}} <span style="
                                                    font-family: none;
                                                    font-size: small;
                                                    color: limegreen;">{{setLabel("ctrlEnterLabel")}}</span></span>
                        </button>
                        &nbsp;&nbsp;
                        <button id="nextMember"
                            *ngIf="!(!subPackage.isGreaterthanNoOfMembers && members.length >= noOfMembers - 1)"
                            [disabled]="!memberSignUpForm.form.valid || isDisableOnTypeEmail || !isAgeValid || !member.contactDetail.contact" (click)="nextMembers()"
                            type="button" class="p-button
                                                    p-widget
                                                    p-state-default
                                                    p-corner-all">
                            <span class="p-button-text p-c"><span
                                    style="font-family: fantasy;color: bisque;">({{members.length}})</span>
                                {{setLabel("nextMemberLabel")}}
                                <span style="
                                                    font-family: none;
                                                    font-size: small;
                                                    color: limegreen;">{{setLabel("shiftArrowRightLabel")}}</span></span>
                            <span *ngIf="loading" class="p-button-icon-left
                                                p-c
                                                fa fa-spinner fa-spin" style="font-size:
                                                24px"></span>
                        </button>

                    </div>

                    <div class="p-g-12" *ngIf="subPackage.isGreaterthanNoOfMembers">
                        <button id="proceedButton" *ngIf="isMembersRegistered" type="button"
                            [disabled]="!memberSignUpForm.form.valid || isDisableOnTypeEmail"
                            (click)="validateMembersSignup()" class="p-button
                                            p-widget
                                            p-state-default
                                            p-corner-all">
                            <span class="p-button-text p-c">{{setLabel("proceedBtnLabel")}} <span style="
                                                    font-family: none;
                                                    font-size: small;
                                                    color: limegreen;">{{setLabel("ctrlEnterLabel")}}</span></span>
                        </button>
                        &nbsp;&nbsp;
                        <button id="nextMember" *ngIf="!isMembersRegistered || subPackage.isGreaterthanNoOfMembers"
                            type="button" [disabled]="!memberSignUpForm.form.valid || isDisableOnTypeEmail"
                            (click)="nextMembers()" class="p-button
                                                    p-widget
                                                    p-state-default
                                                    p-corner-all">
                            <span class="p-button-text p-c"><span
                                    style="font-family: fantasy;color: bisque;">({{members.length}})</span>
                               {{setLabel("nextMemberLabel")}}
                                <span style="
                                                    font-family: none;
                                                    font-size: small;
                                                    color: limegreen;">{{setLabel("shiftArrowRightLabel")}}</span></span>
                            <span *ngIf="loading" class="p-button-icon-left
                                                p-c
                                                fa fa-spinner fa-spin" style="font-size:
                                                24px"></span>
                        </button>

                        &nbsp;&nbsp;
                        <!-- *ngIf="members.length >= subPackage.noOfMembers && subPackage.isGreaterthanNoOfMembers" -->
                        <!-- "memberSignUpForm.form.valid" -->
                        <button id="escButton"
                            *ngIf="members.length >= subPackage.noOfMembers && subPackage.isGreaterthanNoOfMembers"
                            (click)="skipMember()" class="p-button p-widget p-state-default p-corner-all" type="button">

                            <span class="p-button-text p-c"> {{setLabel("skipBtnLabel")}}
                                <span style="font-family: none;font-size: small;color: limegreen;">{{setLabel("escBtnLabel")}}</span>
                            </span>

                            <span *ngIf="loading" class="p-button-icon-left p-c fa fa-spinner fa-spin"
                                style="font-size: 24px"></span>
                        </button>
                    </div>
                </form>
            </div>
            <!-- </p-accordionTab> -->
            <div style="clear: both"></div>

            <!-- </p-accordionTab> -->
        </p-accordionTab>

        <div style="clear: both"></div>

        <p-accordionTab [disabled]="true" [header]='setLabel("registerLabel")'>
            <div class="p-g multiple-signup-detail-2-res">
                <div class="p-g-12 personal-training-session">
                    <form #trainerForm="ngForm">
                        <div class="p-g" *ngIf="noOfMembers===1">
                            <h3 class="first">
                                {{setLabel("personalTrainingSession?Label")}}
                            </h3>
                            <div class="p-g-12 personal-training-session-radioButton">
                                <div class="p-g-2">
                                    <p-radioButton name="question3" value="YES" [label]='setLabel("yESLabel")'
                                        [(ngModel)]="member.question3" inputId="opt5" class="p-label-active">
                                    </p-radioButton>
                                </div>
                                <div class="p-g-2">
                                    <p-radioButton name="question3" value="NO" [label]='setLabel("nOLabel")' [(ngModel)]="member.question3"
                                        inputId="opt6">
                                    </p-radioButton>
                                </div>
                            </div>

                            <div class="p-g-6" *ngIf="member.question3 ==
                                        'YES'">
                                <span style="color: #000000 !important">Trainer Fee DueDate(F9):&nbsp;
                                    <p-calendar [yearNavigator]="true" id="tFeeDueDate" yearRange="1950:2040"
                                        [monthNavigator]="true" required [ngModelOptions]="{
                                                standalone: true
                                                }" [(ngModel)]="member.customerstrainer.dueDate" [placeholder]='setLabel("dueDatePlaceholderLabel")'
                                        name="trainerDueDate" #dueDate="ngModel" [inline]="false" dateFormat="dd/mm/yy"
                                        [showIcon]="true">
                                    </p-calendar>
                                </span>
                                <div *ngIf="dueDate.invalid &&
                                            (dueDate.dirty || dueDate.touched)">
                                    <div *ngIf="dueDate.errors.required" class="errorShow">
                                        {{setLabel("dueDateRequiredErrorLabel")}}
                                    </div>
                                    <div *ngIf="dueDate.errors.pattern" class="errorShow">
                                        {{setLabel("charactersAllowedErrorLabel")}}
                                    </div>
                                </div>
                            </div>

                            <div class="p-g-6" *ngIf="member.question3 ==
                                        'YES'">
                                <span style="color: #000000 !important">{{setLabel("trainerFee:Label")}}
                                    <input style="width: 75% !important" type="number" autocomplete="off"
                                        id="trainerFee" required pInputText [placeholder]='setLabel("trainerFeePlaceholderLabel")' name="totalFees"
                                        [(ngModel)]="member.customerstrainer
                                                .totalFees" /></span>&nbsp;
                                &nbsp;&nbsp;
                            </div>
                            <div class="p-g-6" *ngIf="member.question3 ==
                                        'YES'">
                                <span style="color: #000000 !important">{{setLabel("selectTrainerLabelF4")}} </span>&nbsp;
                                <p-dropdown [ngModelOptions]="{ standalone:
                                            true }" id="selectTrainer" [options]="options" [(ngModel)]="selectedOption"
                                    (onChange)="dropdownChange()">
                                </p-dropdown>
                                &nbsp;&nbsp;
                            </div>
                            <div class="p-g-6" *ngIf="member.question3 ==
                                        'YES'">
                                <span style="color: #000000 !important">{{setLabel("trainerShare:Label")}}
                                    <input style="width: 75% !important" type="number" autocomplete="off"
                                        id="trainerShare" required pInputText [placeholder]='setLabel("trainerSharePlaceholderLabel")'
                                        name="trainerShare" [(ngModel)]="member.customerstrainer
                                                .trainerShare" /></span>&nbsp;
                                &nbsp;&nbsp;
                            </div>
                            <div class="p-g-6" *ngIf="member.question3 ==
                                        'YES'">
                                <span style="color: #000000 !important">{{setLabel("gymShare:Label")}}
                                    <input style="width: 44% !important" type="number" autocomplete="off" id="gymShare"
                                        required pInputText [placeholder]='setLabel("gymSharePlaceholderLabel")' name="gymShare"
                                        [(ngModel)]="member.customerstrainer.gymShare" /></span>
                                &nbsp; &nbsp;&nbsp;
                            </div>
                        </div>
                        <div class="p-g-12" *ngIf="subPackage.noOfMembers > 1">

                            <div class="p-g-12" style="text-align: initial;">
                                <!-- <h3 class="first">
                                    {{setLabel("groupPersonalTraining:Label")}}
                                </h3> -->
                                <!-- <div class="p-g-6" style="display: grid !important;height: 120px !important;">
                                            <p-checkbox name="group1" value="val1" label="2 Persons"
                                                [(ngModel)]="selectedValues"  ></p-checkbox>
                                            <p-checkbox name="group1" value="val2" label="3 Persons"
                                                [(ngModel)]="selectedValues" ></p-checkbox>
                                            <p-checkbox name="group1" value="val3" label="4 or more Persons"
                                                [(ngModel)]="selectedValues" ></p-checkbox>

                                        </div> -->
                                <!-- <div class="p-g-12" style="display: grid !important;height: 120px !important;">
                                    <div class="p-g-2">
                                        <p-radioButton name="group11" (onClick)="clearCustomerTrainer('2P')" value="2P"
                                            label="2 Persons" [(ngModel)]="member.gPTQuestion" inputId="2per"
                                            id="gPTQuestion" class="p-label-active">
                                        </p-radioButton>
                                    </div>
                                    <div class="p-g-2">
                                        <p-radioButton name="group22" (onClick)="clearCustomerTrainer('3P')" value="3P"
                                            label="3 Persons" [(ngModel)]="member.gPTQuestion" id="gPTQuestion"
                                            inputId="3per">
                                        </p-radioButton>
                                    </div>
                                    <div class="p-g-2" style="white-space: nowrap;">
                                        <p-radioButton name="group33" (onClick)="clearCustomerTrainer('4P')" value="4P"
                                            label="4 or more persons" [(ngModel)]="member.gPTQuestion" id="gPTQuestion"
                                            inputId="4per">
                                        </p-radioButton>
                                    </div>

                                </div> -->

                            </div>
                            <!-- <div>
                                <p-table [value]="members" [paginator]="true" [rows]="10" [loading]="loading"
                                    [style]="{'text-align':'initial'}">
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th>MemberShip No</th>
                                            <th>Name</th>
                                            <th>Contact</th>
                                            <th>Select Trainer</th>
                                            <th>Trainer Fee</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-member>
                                        <tr>
                                            <td>{{ member.tagNumber }}</td>
                                            <td>{{ member.name }}</td>
                                            <td>{{ member.contactDetail.contact }}</td>
                                            <td>
                                                <p-dropdown [ngModelOptions]="{standalone: true}"
                                                    [options]="options" [(ngModel)]="member.customerstrainer.trainerId"
                                                    (onChange)="dropdownChange1(member)">
                                                </p-dropdown>
                                            </td>
                                            <td>
                                                <input type="number" [ngModelOptions]="{standalone: true}"
                                                    autocomplete="off" pInputText
                                                    placeholder="Trainer Fee" name="totalFees"
                                                    [(ngModel)]="member.customerstrainer.totalFees" />
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                            <div *ngIf="member.gPTQuestion=='3P'">
                                <p-table [value]="members" [paginator]="true" [rows]="10" [loading]="loading"
                                    [style]="{'text-align':'initial'}">
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th>MemberShip No</th>
                                            <th>Name</th>
                                            <th>Contact</th>
                                            <th>Select Trainer</th>
                                            <th>Trainer Fee</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-member>
                                        <tr>
                                            <td>{{ member.tagNumber }}</td>
                                            <td>{{ member.name }}</td>
                                            <td>{{ member.contactDetail.contact }}</td>
                                            <td>
                                                <p-dropdown [ngModelOptions]="{standalone: true}" [disabled]="count>2"
                                                    [options]="options" [(ngModel)]="member.customerstrainer.trainerId"
                                                    (onChange)="dropdownChange1(member)">
                                                </p-dropdown>
                                            </td>
                                            <td>
                                                <input type="number" [ngModelOptions]="{standalone: true}"
                                                    autocomplete="off" [disabled]="count>2" pInputText
                                                    placeholder="Trainer Fee" name="totalFees"
                                                    [(ngModel)]="member.customerstrainer.totalFees" />
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div> -->
                            <div>
                                <!-- <p-table [value]="members" [paginator]="true" [rows]="10" [loading]="loading"
                                    class="p-table-tecfolk-fix"> -->
                                    <!-- <ng-template pTemplate="header">
                                        <tr>
                                            <th>{{setLabel("memberShipNoLabel")}}</th>
                                            <th>{{setLabel("nameLabel")}}</th> -->
                                            <!-- <th>Contact</th> -->
                                            <!-- <th>{{setLabel("selectTrainerLabel")}}</th>
                                            <th style="text-align: center;">{{setLabel("trainerFeeLabel")}}</th>
                                            <th style="text-align: center;">{{setLabel("sessionsBookedLabel")}}</th>

                                            <th>{{setLabel("joiningDateLabel")}}</th>
                                        </tr>
                                    </ng-template> -->
                                    <!-- <ng-template pTemplate="body" let-member let-rowIndex="rowIndex">
                                        <tr id="rowTrainer-{{rowIndex}}"> -->
                                            <!-- <td>
                                                <div class="mobile-label">{{setLabel("memberShipNoLabel")}}</div>
                                                <div>{{ member.tagNumber }}</div>
                                            </td>
                                            <td>
                                                <div class="mobile-label">{{setLabel("nameLabel")}}</div>
                                                <div>{{ member.name }}</div>
                                            </td> -->
                                            <!-- <td>{{ member.contactDetail.contact }}</td> -->
                                            <!-- <td>
                                                <div class="mobile-label">{{setLabel("selectTrainerLabel")}}</div>
                                                <div>
                                                    <p-dropdown [ngModelOptions]="{standalone: true}" [options]="options"
                                                        [(ngModel)]="member.customerstrainer.trainerId"
                                                        (onChange)="dropdownChange1(member)"
                                                        id="selectTrainer-{{rowIndex}}">
                                                    </p-dropdown>
                                                </div>
                                            </td> -->
                                            <!-- <td style="text-align: center;">
                                                <div class="mobile-label">{{setLabel("trainerFeeLabel")}}</div>
                                                <div>
                                                    <input type="number" [ngModelOptions]="{standalone: true}"
                                                        autocomplete="off" disabled="true" pInputText
                                                        [placeholder]='setLabel("trainerFeePlaceholderLabel")' name="totalFees"
                                                        id="trainerFees-{{rowIndex}}" (input)="onChangeTrainerFee($event)"
                                                        [(ngModel)]="member.customerstrainer.totalFees" min="0"
                                                        style="width: 80% !important;" required />
                                                </div>
                                            </td> -->
                                            <!-- <td style="text-align: center;">
                                                <div class="mobile-label">{{setLabel("sessionsBookedLabel")}}</div>
                                                <div>
                                                <input type="number" id="sessionCount" (change)="setSessionCount($event.target.value,member)"
                                                style="width: 80% !important;">
                                                </div>
                                            </td> -->
                                            <!-- <td style="text-align: center; display: none;">
                                                <div class="mobile-label">{{setLabel("gymShareLabel")}}</div>
                                                <div>
                                                    <input type="number" [ngModelOptions]="{standalone: true}"
                                                        autocomplete="off" disabled="true" pInputText
                                                        [placeholder]='setLabel("gymSharePlaceholderLabel")' name="gymShare" id="gymShare-{{rowIndex}}"
                                                        (input)="getTrainerShare()" min="0"
                                                        [(ngModel)]="member.customerstrainer.gymShare"
                                                        style="width: 80% !important;" required />
                                                </div>
                                            </td> -->
                                            <!-- <td style="text-align: center; display: none;">
                                                <div class="mobile-label">{{setLabel("trainerShareLabel")}}</div>
                                                <div>
                                                    <input type="number" [ngModelOptions]="{standalone: true}"
                                                        autocomplete="off" disabled="true" pInputText
                                                        [placeholder]='setLabel("trainerSharePlaceholderLabel")' name="trainerShare"
                                                        id="trainerShare-{{rowIndex}}"
                                                        [(ngModel)]="member.customerstrainer.trainerShare"
                                                        style="width: 80% !important;" required />
                                                </div>
                                            </td> -->
<!--
                                            <td>
                                                <div class="mobile-label">{{setLabel("joiningDateLabel")}}</div>
                                                <div>
                                                    <p-calendar disabled="true" [yearNavigator]="true" yearRange="1950:2040"
                                                        [monthNavigator]="true" required
                                                        [ngModelOptions]="{standalone: true}"
                                                        [(ngModel)]="member.joiningDate" [placeholder]='setLabel("dueDatePlaceholderLabel")'
                                                        name="trainerDueDate" #dueDate="ngModel" [inline]="false"
                                                        dateFormat="dd/mm/yy" [showIcon]="true">
                                                    </p-calendar>
                                                </div>
                                            </td> -->
                                        <!-- </tr>
                                    </ng-template> -->
                                <!-- </p-table> -->
                            </div>

                        </div>

                    </form>
                </div>

                <div class="p-g-12">
                    <div class="p-g-3"></div>
                    <div class="p-g-6" style="text-align: center">
                        &nbsp;&nbsp;
                        <button id="registerButton" *ngIf="this.isMembersRegistered" (click)="signup()"
                            [disabled]="!trainerForm.form.valid || isGymShareMoreThanTrainerFee" class="p-button
                                            p-widget
                                            p-state-default
                                            p-corner-all">
                            <span class="p-button-text p-c">{{setLabel("registerLabel")}} <span style="
                                font-family: none;
                                font-size: small;
                                color: limegreen;">{{setLabel("ctrlEnterLabel")}}</span> </span>
                        </button>
                    </div>
                    <div class="p-g-3"></div>
                </div>
            </div>

        </p-accordionTab>
        <div style="clear: both"></div>
    </p-accordion>
</div>
<div class="p-g-12">
    <!-- <button id="loginbtn" [disabled]="loading" (click)="reverse()"
        class="p-button p-widget p-state-default p-corner-all">
        <span class="p-button-text p-c">back</span>
        <span *ngIf="loading" class="p-button-icon-left p-c fa fa-spinner fa-spin" style="font-size:24px"></span>
      </button>&nbsp;&nbsp;
      <button id="loginbtn" *ngIf="package.noOfMembers==index-1" [disabled]="!memberSignUpForm.form.valid"
        (click)="validateSignup()" class="p-button p-widget p-state-default p-corner-all">
        <span class="p-button-text p-c">Next</span>
        <span *ngIf="loading" class="p-button-icon-left p-c fa fa-spinner fa-spin" style="font-size:24px"></span>
      </button> -->
</div>

<div *ngIf="dialogVisibility" class="tecfolkProfileDialogFix">
    <p-dialog [header]='setLabel("addProfilePhotoHeaderLabel")' [(visible)]="dialogVisibility">
        <app-add-profile-image [popupType]="addProfileImage" (closeThePopup)="hideAddProfileImage()"
            (outputImage)="handleImagefromNewProfile($event)"></app-add-profile-image>
    </p-dialog>
    <!-- popupType : Upload | Cam -->
</div>

<div style="text-align: left !important;">
    <p-dialog [closeOnEscape]="true" [(visible)]="existingMembersDialog" [focusOnShow]="false"
        [style]="{width: '340px', left:'448px', top:'23px'}">
        <p-header>
           {{setLabel("addExistingMemberLabel")}}
        </p-header>
        <form #existingMemberForm="ngForm">
            <div class="p-g-12 p-md-12" style="height: 38vh;">
                <div class="p-inputgroup">
                    <p-dropdown id="aEM" (onChange)="AddExistingOnchange()" [ngModelOptions]="{ standalone: true }"
                        required="required" [options]="existMembersddOptions" class="dd-fullwidth"
                        [(ngModel)]="selectedExistMember" [virtualScroll]="true" [itemSize]="3" filter="true"
                        filterBy="label" [style]="{'width':'100%','display':'grid','text-align':'left'}"
                        [placeholder]='setLabel("selectAMemberPlaceholderLabel")' [showClear]="true" filter="true">
                        <ng-template let-item pTemplate="selectedItem">
                            <span style="display: flex;
                            text-align: left;
                            vertical-align: middle">{{ item.label }}</span>
                        </ng-template>
                        <ng-template let-mem pTemplate="item">
                            <div class="p-helper-clearfix" style="position:
                                relative; height: 25px">
                                <div style="font-size: 14px;
                                    margin-top: 4px;">
                                    {{ mem.label }}
                                </div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
            </div>
            <p-footer>
                <div class="p-g-12 p-md-12">
                    <div class="p-g-12 p-md-12" style="margin-bottom: 6px; text-align: center;">
                        <button (click)="addExistngMember()"
                            style="width: 100%; padding-top: 6px; justify-content: center;" id="addExisMemberSave"
                            type="button" pButton class="addExisMemberSavep-button-success"
                            [disabled]="!existingMemberForm.valid || memberAlreadySelected == true || selectedExistMember == undefined">
                            <i class="pi pi-save"></i>
                            &nbsp;<span>{{setLabel("saveBtnLabel")}}</span>
                        </button>
                        <p style="margin: 0px;font-size: small; font-family: monospace;">{{setLabel("pressCTRLDropdownLabel")}}</p>
                    </div>
                    <div class="p-g-12 p-md-12" class="alert alert-danger" style="margin-bottom: 6px;"
                        *ngIf="memberAlreadySelected">
                        <p-message severity="error" text="Member already selected for this Package">
                        </p-message>
                    </div>
                </div>

            </p-footer>

        </form>
    </p-dialog>
</div>
